import * as React from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import logoCRM from "../assets/logos/cruz-roja-logo.png";
import logoCapa from "../assets/logos/capacitacion-logo.png";
import { FaHome, FaBars } from "react-icons/fa";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

const Navbar = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentLabel, setCurrentLabel] = useState("");
  const isMobile = useMediaQuery('(max-width:768px)');

  const handleClick = (path, label) => {
    navigate(path);
    setCurrentLabel(label);
    setDrawerOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const menuItems = [
    { path: "/Catalogo", label: "CATÁLOGO" },
    { path: "/Sedes", label: "SEDES" },
    { path: "/Certificados", label: "CERTIFICADOS" },
    { path: "/Nosotros", label: "CONÓCENOS" },
    { path: "/Transparencia", label: "TRANSPARENCIA" },
    { path: "/Plataforma", label: "PLATAFORMA DIGITAL" }
  ];

  const DivOne = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: white;
    padding: 10px 0;
    height: 60px;
  `;

  const Logo = styled.img`
    height: 60px;
    margin-right: 20px;
    margin-left: 10px;
  `;

  const DivTwo = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    padding: 0px;
    background-color: #12b854;
  `;

  const DivAll = styled.div`
    height: 120px;
    position: sticky;
    top: 0;
    z-index: 1000;
  `;

  const NavButton = styled(Button)`
    font-family: "Oswald", serif;
    font-size: 20px;
    font-weight: 400;
    border-radius: 0;
    height: 100%;
    padding: 0 30px;
    border-right: 2px solid #0d6834;
    background-color: transparent;
    color: white;
    &:hover {
      background-color: #0d6834;
      color: white;
    }
  `;

  const NavButtonMobile = styled(Button)`
    font-family: "Oswald", serif;
    font-size: 20px;
    font-weight: 400;
    border-radius: 0;
    height: 100%;
    padding: 0 30px;
    border-bottom: 2px solid #0d6834;
    background-color: transparent;
    color: black;
    &:hover {
      background-color: #0d6834;
      color: white;
    }
  `;

  return (
    <DivAll>
      <DivOne>
        <Logo src={logoCRM} alt="Logo izquierdo" />
        <Logo src={logoCapa} alt="Logo derecho" />
      </DivOne>

      {isMobile ? (
        <DivTwo>
          <IconButton onClick={() => setDrawerOpen(true)}>
            <FaBars size={30} color="white" />
          </IconButton>
          <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
            <Stack spacing={2} sx={{ width: 250, padding: 2 }}>
              <NavButtonMobile onClick={() => handleClick("/", "")} startIcon={<FaHome />}>
                INICIO
              </NavButtonMobile>
              {menuItems.map(({ path, label }) => (
                <NavButtonMobile
                  key={label}
                  onClick={() => handleClick(path, label)}
                  sx={{
                    color: currentLabel === label ? "black" : "white"
                  }}
                >
                  {label}
                </NavButtonMobile>
              ))}
            </Stack>
          </Drawer>
        </DivTwo>
      ) : (
        <DivTwo>
          <Button 
            variant="contained"
            onClick={() => handleClick("/")}
            sx={{
              backgroundColor: "#0d6834",
              borderRadius: "0px",
              padding: "0px 30px",
              fontFamily: "Oswald, serif",
              fontSize: "20px",
              fontWeight: "400",
              color: "white",
              borderRight: "2px solid #0d6834",
              height: "100%",
              "&:hover": { color: "white", backgroundColor: "#0d6834" }
            }}
          >
            <FaHome size={30} color="white" />
          </Button>
          <Stack direction="row" spacing={0}>
            {menuItems.map(({ path, label }) => (
              <NavButton
                key={label}
                onClick={() => handleClick(path, label)}
                sx={{
                  color: currentLabel === label ? "black" : "white"
                }}
              >
                {label}
              </NavButton>
            ))}
          </Stack>
        </DivTwo>
      )}
    </DivAll>
  );
};

export default Navbar;
